// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"df9c39b9","769":"6c1c3340"}[chunkId] + ".chunk.js";
};